import { Injectable } from '@angular/core';
import { ISearchCriteria, ISearchResult } from 'app/core/interfaces/advance-search.interface';

@Injectable()
export class AdvanceSearchStateService {
  private criteria: ISearchCriteria | null = null;
  private results: ISearchResult[] | null = null;

  get currentCriteria(): ISearchCriteria | null {
    return this.criteria;
  }

  get currentResults(): ISearchResult[] | null {
    return this.results;
  }

  updateCriteria(criteria: ISearchCriteria): void {
    this.criteria = criteria;
  }

  updateResults(results: ISearchResult[]): void {
    this.results = results;
  }

  clear(): void {
    this.criteria = null;
    this.results = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/advance-search-state.service.ts